import React from "react";
import { TextField, InputAdornment } from "@mui/material";

const CustomTextField = ({
  id,
  label,
  name,
  placeholder,
  icon,
  onChange,
  value = "",
}) => {
  return (
    <TextField
      margin="normal"
      id={id}
      label={label}
      name={name}
      placeholder={placeholder}
      InputProps={{
        startAdornment: (
          <InputAdornment position="start">{icon}</InputAdornment>
        ),
        sx: {
          borderRadius: 1,
        },
      }}
      sx={{
        width: "100%",
      }}
      value={value}
      onChange={onChange}
    />
  );
};

export default CustomTextField;
